module.exports = __webpack_public_path__ + "img/bank-building (2).80d917a3.svg";